<template>
  <div class="childtrackingsystem-observationform">
    <div class="row bg-white" v-if="isError">
      <div class="col-12 alert alert-danger text-center">Er is een fout opgetreden tijdens het opslaan van observatieformulier</div>
    </div>
    <div class="row bg-white" v-if="isSuccess">
      <div class="col-12 alert alert-info text-center">Observatieformulier is succesvol opgeslagen</div>
    </div>
    <div class="row bg-white pt-1">
      <div class="col-10 pt-2"><b>{{ list.title }}</b> van kind <b>{{ childDetails.full_name }}</b> ({{ childDetails.age }} maanden)</div>
      <div class="col-2 text-end pe-1 pt-2">
        <button class="btn btn-outline-secondary" @click="goBack()">Terug</button>
      </div>
    </div>
    <div class="row row-cols-auto align-items-center bg-white py-3">
        <div class="col col-form-label fw-bold">Observatieformulier antwoorden</div>
        <div class="col">
            <select
                class="form-select form-select-sm"
                id="answerOption"
                name="answerOption"
                v-model="answerOption"
                @change="changeAnswerOption($event)"
            >
                <option value="last">Zie laatste</option>
                <option value="all">Zie alle antwoorden (kind traject)</option>
            </select>
        </div>
    </div>
    <div class="row bg-white">
      <div class="col-12">
        <table v-for="(category, cIdx) in categories" v-bind:key="cIdx" style="border:0;width:100%;">
          <tr v-if="category.questions.length > 0" class="header">
            <th :style="'border:0; height: 50px; padding-left: 15px;color:' + category.color" colspan="3">
              {{ category.name }}
            </th>
          </tr>
          <tr v-for="(question, cqIdx) in category.questions" v-bind:key="cqIdx" class="borderBottomShadow">
            <td style="border:0;width:15px;">&nbsp;&nbsp;</td>
            <td style="border:0;padding-top:10px;vertical-align: middle;margin-right: 15px;margin-left: 15px;">
              {{ question.vraag }}
            </td>
            <td style="border:0;width:700px;padding-top:10px;vertical-align: middle;">
              <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                <tr v-if="answerOption === 'last' && question.freeAnswer === false">
                  <td v-for="answer in question.answers"
                      v-bind:key="answer.id"
                      style="vertical-align: middle; padding-left: 200px;">
                    <input type='text'
                           value=''
                           size='4'
                           :title="answer.updated"
                           :style="'background-color:' + answer.color + ';border:0; border-radius: 50%;margin-left:5px;width:25px;height:25px;'"/>
                    <span v-if="answer.answer !== 'Vul antwoord in'">{{ answer.answer }}</span>
                  </td>
                </tr>
                <tr v-if="answerOption === 'all' && question.freeAnswer === false">
                  <td style="border:0;width:700px; height: 50px;">
                    <table style="width: 100%;">
                      <tr style="border:0;border-bottom: 1px solid #000000 !important;">
                        <td v-for="(answer, aIdx) in question.answersTable"
                            v-bind:key="aIdx"
                            :style="'background-color:' + answer.bgcolor + ';border:0;'">
                          <div :title="answer.date"
                               :style="'display:inline-block;' +
                                            'background-color:' + answer.color + ';' +
                                            'border:' + answer.border + ';' +
                                            'border-radius: 50%;' +
                                            'width:18px;' +
                                            'height:16px;'"></div>
                        </td>
                      </tr>
                      <tr style="border:0;">
                        <td v-for="(answer, aIdx) in question.answersTable"
                            v-bind:key="aIdx"
                            :style="'background-color:' + answer.bgcolor + ';border:0;'">
                          <div v-if="(aIdx < question.answersTable|length-1)"
                               :title="answer.date"
                               :style="'display:inline-block;' +
                                            'color: #666;' +
                                            'background-color:' + answer.bgcolor + ';' +
                                            'border:0;' +
                                            'border-radius: 50%;' +
                                            'width:25px;' +
                                            'height:25px;'">
                            {{ answer.ageChild }}
                          </div>
                          <div v-if="(aIdx === question.answersTable|length - 1)"
                               :title="answer.date"
                               :style="'display:inline-block;' +
                                            'color: #666;' +
                                            'background-color:' + answer.bgcolor + ';' +
                                            'border:0;' +
                                            'border-radius: 50%;' +
                                            'width:25px;' +
                                            'height:25px;' +
                                            'text-align:right;'">
                            {{ answer.ageChild }}
                          </div>
                          <div v-if="(answer.ageChild === answer.actualChildAge)"
                               style="position:absolute;
                                          display: inline-block;
                                          width: 0;
                                          height: 0;
                                          margin-top: -1px;
                                          margin-left: -24px;
                                          margin-bottom: 10px;
                                          border-left: 8px solid transparent;
                                          border-right: 8px solid transparent;
                                          border-top: 8px solid red;">
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr v-if="answerOption === 'all' && question.freeAnswer === true">
                  <td style="border:0;width:700px; height: 50px;">
                    <div v-for="(answer, aIdx) in question.answers"
                         v-bind:key="aIdx">
                       <b>{{ answer.date }} ({{ answer.ageChild }} maanden)</b> -  {{ answer.note }} <br>
                    </div>
                  </td>
                </tr>
                <tr v-if="question.noteChecked === 'checked' && answerOption === 'last'">
                  <td style="vertical-align: middle; padding-left: 200px;">
                    <textarea class="form-control"
                              :id="'answerNote-' + question.id"
                              :ref="'answerNote-' + question.id"
                              style="width: 300px;"
                              v-on:input="changeAnswerNote($event, question.id)"
                              v-model="answerNote[question.id]">
                    </textarea>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr><td colspan="3">
          <table v-for="(subcategory, cIdx) in category.subcategories" v-bind:key="cIdx" style="border:0;width:100%;">
            <tr class="header">
              <th :style="'border:0; height: 50px; padding-left: 15px;color:' + subcategory.color" colspan="3">
                {{ category.name }}: {{ subcategory.name }}
              </th>
            </tr>
            <tr v-for="(subquestion, cqIdx) in subcategory.questions" v-bind:key="cqIdx" class="borderBottomShadow">
              <td style="border:0;width:15px;">&nbsp;&nbsp;</td>
              <td style="border:0;padding-top:10px;vertical-align: middle;margin-right: 15px;margin-left: 15px;">
                {{ subquestion.vraag }}
              </td>
              <td style="border:0;width:700px;padding-top:10px;vertical-align: middle;">
                <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                  <tr v-if="answerOption === 'last'">
                    <td v-for="answer in subquestion.answers"
                        v-bind:key="answer.id"
                        style="vertical-align: middle; padding-left: 200px;">
                      <input type='text'
                             value=''
                             size='4'
                             :title="answer.updated"
                             :style="'background-color:' + answer.color + ';border:0; border-radius: 50%;margin-left:5px;width:25px;height:25px;'"/>
                      <span v-if="answer.answer !== 'Vul antwoord in'">{{ answer.answer }}</span>
                    </td>
                  </tr>
                  <tr v-if="answerOption === 'all' && subquestion.freeAnswer === false">
                    <td style="border:0;width:700px; height: 50px;">
                      <table style="width: 100%;">
                        <tr style="border:0;border-bottom: 1px solid #000000 !important;">
                          <td v-for="(answer, aIdx) in subquestion.answersTable"
                              v-bind:key="aIdx"
                              :style="'background-color:' + answer.bgcolor + ';border:0;'">
                            <div :title="answer.date"
                                 :style="'display:inline-block;' +
                                            'background-color:' + answer.color + ';' +
                                            'border:' + answer.border + ';' +
                                            'border-radius: 50%;' +
                                            'width:18px;' +
                                            'height:16px;'"></div>
                          </td>
                        </tr>
                        <tr style="border:0;">
                          <td v-for="(answer, aIdx) in subquestion.answersTable"
                              v-bind:key="aIdx"
                              :style="'background-color:' + answer.bgcolor + ';border:0;'">
                            <div v-if="(aIdx < subquestion.answersTable|length-1)"
                                 :title="answer.date"
                                 :style="'display:inline-block;' +
                                            'color: #666;' +
                                            'background-color:' + answer.bgcolor + ';' +
                                            'border:0;' +
                                            'border-radius: 50%;' +
                                            'width:25px;' +
                                            'height:25px;'">
                              {{ answer.ageChild }}
                            </div>
                            <div v-if="(aIdx === subquestion.answersTable|length - 1)"
                                 :title="answer.date"
                                 :style="'display:inline-block;' +
                                            'color: #666;' +
                                            'background-color:' + answer.bgcolor + ';' +
                                            'border:0;' +
                                            'border-radius: 50%;' +
                                            'width:25px;' +
                                            'height:25px;' +
                                            'text-align:right;'">
                              {{ answer.ageChild }}
                            </div>
                            <div v-if="(answer.ageChild === answer.actualChildAge)"
                                 style="position:absolute;
                                          display: inline-block;
                                          width: 0;
                                          height: 0;
                                          margin-top: -1px;
                                          margin-left: -24px;
                                          margin-bottom: 10px;
                                          border-left: 8px solid transparent;
                                          border-right: 8px solid transparent;
                                          border-top: 8px solid red;">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="answerOption === 'all' && subquestion.freeAnswer === true">
                    <td style="border:0;width:700px; height: 50px;">
                      <div v-for="(answer, aIdx) in subquestion.answers"
                           v-bind:key="aIdx">
                        <b>{{ answer.date }} ({{ answer.ageChild }} maanden)</b> -  {{ answer.note }} <br>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="subquestion.noteChecked === 'checked' && answerOption === 'last'">
                    <td style="vertical-align: middle; padding-left: 200px;">
                    <textarea class="form-control"
                              :id="'answerNote-' + subquestion.id"
                              :ref="'answerNote-' + subquestion.id"
                              style="width: 300px;"
                              v-on:input="changeAnswerNote($event, subquestion.id)"
                              v-model="answerNote[subquestion.id]">
                    </textarea>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
            </td>
          </tr>
          <tr>
            <td style="border:0;vertical-align: top;padding: 10px; " colspan="3">
              <div v-if="category.noteChecked === 'checked'">
                <b>{{category.name}} opmerkingen</b>
                <textarea class="form-control" :id="'categoryNote-' + category.id"
                          style="height: 100px;"
                          v-model="categoryNote[category.id]"
                          v-on:input="changeCategoryNote($event, category.id)"></textarea>
              </div>
            </td>
          </tr>
          <tr v-if="!isEndForm">
            <td style="border:0;" colspan="3">
              <button :id="'upload-' + category.id" class="btn btn-outline-warning"
                      @click="uploadPhoto($event,idResult, category.id)">Upload foto
              </button>
              <button :id="'add-' + category.id" class="btn btn-outline-warning" @click="addPhoto(idResult, category.id)"
                      style="margin-left: 15px;">Foto's toevoegen
              </button>
            </td>
          </tr>
          <tr>
            <td
                style="border:0;"
                colspan="3"
            >
                <span class="mt-2 me-2 text-center" v-for="image in categoryPhotos[category.id]"
                      :key="image.id" style="position: relative; height: 200px;">
              <img class="mb-2"
                   :src="image.src"
                   :title="image.filename"
                   :alt="image.filename"
                   height="150"/>
                  <button v-if="!isEndForm"
                          class="btn btn-sm btn-danger delete-image"
                          @click="deleteImage(image.id)">
                    <icon name="delete"></icon>
                  </button>
                </span>
            </td>
          </tr>
        </table>
        <br><br>
        <table style="width:100%; height:150px; border:0;"
        >
          <tr v-if="list.noteChecked === 'checked'">
            <td style="border:0;vertical-align: top;padding: 10px;">
              <div>
                <b>Algemene opmerkingen</b><br>
                <textarea class="text-input form-control" id="listNote"
                          style="height: 100px;" v-model="list.note"
                          v-on:input="changeListNote($event)"></textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td style="border:0;vertical-align: top;padding: 10px;">
              <b>Bijzonderheden</b><br>
              <textarea class="text-input form-control" id="formNote"
                        style="height: 100px;" v-model="formNote"
                        v-on:input="changeFormNote($event)"></textarea>
            </td>
          </tr>
        </table><br>
      </div>
    </div>
    <div class="row bg-white"><br><br><div class="modalLoader" v-if="isLoading">
      <img src="../../assets/img/loading.gif" alt="loading..." style="width: 80px; height: 80px;"/>
    </div></div>

    <div class="row row-cols-auto align-items-end pb-3 bg-white">
      <div class="col">
        <button class="btn btn-outline-secondary" @click="goBack()">Terug</button>
      </div>
      <div class="col">
        <button class="btn btn-outline-secondary"
                v-if="formActive"
                title="Zet in archief"
                @click="changeFormStatus(idChildForm, false)"
        >Zet in archief</button>
        <button class="btn btn-outline-secondary"
                v-if="!formActive"
                title="Haal uit archief"
                @click="changeFormStatus(idChildForm, true)"
        >Haal uit archief</button>
      </div>
      <div v-if="viewStatus" class="col">
        <label class="form-label">Status</label>
        <select
                class="form-select form-select-sm"
                id="formStatus"
                name="formStatus"
                @change="formStatusChanged($event)" v-model="formStatus">
          <option value='in ontwikkeling'>In ontwikkeling</option>
          <option value='definitief'>Definitief</option>
        </select>
      </div>
      <div class="col">
        <label class="form-label">Ingevuld door</label>
        <select class="form-select form-select-sm" name="mentor" id="mentor"
                v-model="selectedMentor"
                @change="mentorChanged($event)">
          <option value="0" selected>Kies</option>
          <option :value="mentor.id" v-bind:key="mentor.id" v-for="mentor in mentors">
            {{ mentor.name }}
          </option>
        </select>
      </div>
      <div class="col">
        <button class="btn btn-outline-primary" @click="saveChildForm()">Opslaan</button>
        <button v-if="idChildForm > 0" type="submit" class="btn btn-outline-danger ms-2" @click="printChildForm();">PDF</button>
      </div>
    </div>
    <div class="row bg-white"><br><br></div>
    <div v-if="isModal" id="uploadModal" class="modalUploadLoader">
      <div class="modal-content">
        <div class="modal-title" style="text-align: right; width:100%; padding-right: 10px;">
          <button class="btn btn-danger" @click="closeModal()">x</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="col-sm-10">
              Foto uploaden:
              <input type="file" id="photo" ref="photo" class="form-control-file" multiple="multiple"><br/>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-primary" type="button" name="upload" value="upload" @click="uploadSave()">Opslaan upload
          </button>
        </div>
      </div>
    </div>
    <div v-if="isAddModal" class="modalAddLoader" id="addModal">
      <div class="modal-content">
        <div class="modal-title" style="text-align: right; width:100%; padding-right: 10px;">
          <button class="btn btn-outline-secondary" @click="closeAddModal()">x</button>
        </div>
        <div class="row">
          <div class="col-sm-10">
            <img v-bind:key="imageMedia.id" v-for="imageMedia in childMedia" :src="imageMedia.src"
                 :title="imageMedia.filename"
                 :alt="imageMedia.filename"
                 :id="'addImage-' + imageMedia.id" style="margin-left: 10px; height: 150px; border: 1pt solid black"
                 @click="selectPhotos(imageMedia.id, imageMedia.filename);"/>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" name="upload" value="upload" @click="addSave()">Toevoegen</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'childtrackingsystem-observationform',
  components: {},
  props: ['idResult','idChildForm'],
  data() {
    return {
      isLoading: false,
      idList: null,
      idChild: null,
      childDetails: [],
      list: [],
      form: [],
      selectedMentor: null,
      idEstablishment: null,
      idGroup: null,
      categories: [],
      categoryNote: [],
      answerNote: [],
      mentors: [],
      listNote:[],
      noteChecked: null,
      answerOption: 'last',
      formStatus: 'in ontwikkeling',
      isEndForm: false,
      isModal: false,
      isAddModal: false,
      formActive: true,
      upload_idCategory: null,
      files: [],
      images: [],
      photos: [],
      childMedia: [],
      selectedPhotos: [],
      categoryPhotos: [],
      formNote: null,
      viewStatus: true,
      isError: false,
      isSuccess: false
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/editChildForm', {
        idResult: this.idResult,
        idChildForm: this.idChildForm,
        answerOption: this.answerOption
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.childDetails = response.child
          this.list = response.list
          this.idList = response.list.idList
          this.idChild = response.child.idChild
          this.categories = response.formContent
          this.form = response.form
          this.formStatus = response.form.selectedFormStatus
          if (this.formStatus === 'definitief') {
            this.isEndForm = true
          }
          this.viewStatus = response.viewStatus
          this.formActive = response.form.active
          this.answerOption = response.answerOption
          this.mentors = response.mentors
          this.selectedMentor = response.selectedMentor
          this.categoryNote = response.categoryNote
          this.answerNote = response.answerNote
          this.formNote = response.form.note
          this.isLoading = false
          this.categoryPhotos = response.categoryPhotos
        }
      })
    },
    mentorChanged(event) {
      this.selectedMentor = event.target.value
      return event.target.value
    },
    formStatusChanged(event) {
      this.formStatus = event.target.value
      return event.target.value
    },
    changeAnswerOption(event) {
      this.answerOption = event.target.value
      this.getResults()
      return event.target.value
    },
    changeAnswerNote(event, questionId) {
      this.answerNote[questionId] = event.target.value
      return this.answerNote[questionId]
    },
    changeCategoryNote(event, categoryId) {
      this.categoryNote[categoryId] = event.target.value
      return this.categoryNote[categoryId]
    },
    changeListNote(event) {
      this.list['note'] = event.target.value
      return this.list['note']
    },
    changeFormNote(event) {
      this.formNote = event.target.value
      return this.formNote
    },
    saveChildForm() {
      this.isSuccess = false
      this.isError = false
      this.isLoading = true
      window.scrollTo(0, 0);
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/saveChildForm', {
        categoryNote: this.categoryNote,
        answerNote: this.answerNote,
        listNote: this.list.note,
        formNote: this.formNote,
        mentor: this.selectedMentor,
        formStatus: this.formStatus,
        idResult: this.idResult,
        idChild: this.idChild,
        idList: this.idList
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.idChildForm) {
          this.isLoading = false
          this.isSuccess = true
          setTimeout(() => this.isSuccess = false, 40000)
          if (!this.idChildForm) {
            this.$router.push('/childtrackingsystem/forms')
          } else {
            this.getResults()
          }
        } else {
          this.isError = true
        }
      })
    },
    uploadPhoto(event, idResult, idCategory) {
      this.isModal = true
      this.upload_idCategory = idCategory
      this.upload_idResult = idResult
      window.scrollTo(0, 0);
    },
    addPhoto(idResult, idCategory) {
      this.isAddModal = true
      this.upload_idCategory = idCategory
      this.upload_idResult = idResult
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/getChildMedia', {
        idResult: idResult,
        idChild: this.idChild,
        idCategory: idCategory
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.media) {
          this.childMedia = response.media
          window.scrollTo(0, 0);
        } else {
          this.isAddModal = false
          alert('Geen photos beschikbaar in fotobibliotheek van dit kindje!')
        }
      })
    },
    selectPhotos(photoId, photoName) {
      if (this.selectedPhotos.includes(photoName)) {
        this.selectedPhotos.splice(this.selectedPhotos.indexOf(photoName), 1)
        document.getElementById("addImage-" + photoId).style.borderColor = 'black'
      } else {
        this.selectedPhotos.push(photoName)
        document.getElementById("addImage-" + photoId).style.borderColor = 'red'
      }
    },
    closeModal() {
      this.isModal = false
    },
    closeAddModal() {
      this.isAddModal = false
      this.selectedPhotos = []
    },
    uploadSave() {
      let files = this.$refs.photo.files
      for (let i = 0; i < files.length; i++) {
        let formData = new FormData();
        formData.append('file', files[i])
        formData.append('upload_idCategory', this.upload_idCategory)
        formData.append('upload_idResult', this.upload_idResult)
        formData.append('idList', this.idList)

        this.$store.commit('REGISTER_ACTIVE_REQUEST')
        this.$request.post('/ChildTrackingSystem/uploadPhoto', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then((response) => {
          this.$store.commit('REMOVE_ACTIVE_REQUEST')
          if (!response) {
            alert("Er is een fout opgetreden tijdens uploaden")
          } else {
            this.categoryPhotos = response.categoryPhotos
          }
        })
      }
      this.closeModal()
    },
  deleteImage (image) {
    let formData = new FormData();
    formData.append('idPhoto', image)
    formData.append('idResult', this.idResult)
    formData.append('idList', this.idList)
    formData.append('session_token', this.session.session_token)
    formData.append('device_token', this.deviceToken)
    this.$store.commit('REGISTER_ACTIVE_REQUEST')
    // eslint-disable-next-line no-undef
    this.$request.post('/ChildTrackingSystem/deletePhoto', formData)
        .then((response) => {
          this.$store.commit('REMOVE_ACTIVE_REQUEST')
          if (!response) {
            alert("Er is een fout opgetreden tijdens het verwijderen van foto")
          } else {
            this.categoryPhotos = response.categoryPhotos
          }
        })
  },
    addSave() {
      let formData = new FormData();
      formData.append('photos', this.selectedPhotos)
      formData.append('session_token', this.session.session_token)
      formData.append('device_token', this.deviceToken)
      formData.append('idCategory', this.upload_idCategory)
      formData.append('idResult', this.upload_idResult)
      formData.append('idList', this.idList)

      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/addPhoto', formData)
          .then((response) => {
            this.$store.commit('REMOVE_ACTIVE_REQUEST')
            if (!response) {
              alert("Er is een fout opgetreden tijdens toevoegen")
            } else {
              this.isAddModal = false
              this.categoryPhotos = response.categoryPhotos
              this.selectedPhotos = []
            }
          })
    },
    printChildForm() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/downloadChildForm', {
        idChildForm: this.idChildForm,
        idResult: this.idResult,
        answerOption: this.answerOption
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.download(response.filename, response.fileContent)
        } else {
            this.isLoading = false
        }
      })
    },
      download(filename, fileContent) {
          var docUrl = document.createElement('a')
          docUrl.href = "data:application/octet-stream;base64," + fileContent
          docUrl.setAttribute('download', filename)
          document.body.appendChild(docUrl)
          docUrl.click()
          this.isLoading = false
      },
    changeFormStatus(idChildForm, status) {
      this.isLoading = true
      this.formActive = status
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/changeFormStatus', {
        idChildForm: idChildForm,
        status: status
      }).then((response) => {
            if (response) {
              this.isLoading = false
              this.$store.commit('REMOVE_ACTIVE_REQUEST')
              window.location.reload()
            }
      })
    },
    goBack() {
      window.location.reload()
    }
  }
}
</script>
<style scoped>

.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 200px;
  width: 700px;
  height: 330px;
  overflow: auto;
}

.modalUploadLoader {
  position: absolute;
  z-index: 1;
  width: 480px;
  height: 300px;
  overflow: hidden;
  left: 100px;
  top: 0;
}

.modalAddLoader {
  position: absolute;
  z-index: 1;
  width: 90%;
  height: 100%;
  overflow: auto;
  left: 100px;
  top: 0;
}

.borderBottomShadow {
  border-bottom: 1px #ddd solid;
  height: 100px;
}

.header {
  color: #445161;
  background-color: #f0f0f5;
}

.delete-image {
  position: absolute;
  bottom: -80px;
  right: -10px;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
</style>